import { Badge, Button, Grid, Group, Menu, Modal, Stack } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import InputField, { InputFieldTypes } from '../components/input_field';
import Table from '../components/table';
import { useApp } from '../contexts/app.context';
import { useLanguage } from '../contexts/language.context';
import { GET_ALL_CARS } from '../services/cars';
import { CREATE_CONTRACT, DELETE_CONTRACT, GET_ALL_CONTRACTS, UPDATE_CONTRACT } from '../services/contracts';
import { GET_ALL_CUSTOMERS } from '../services/customers';
import { GET_ALL_PLANS } from '../services/plans';
import { carColors, getExtenseDatetime } from '../utility/util';

export default function MaintenancesPage() {
    const [cars, setCars] = useState<any[]>([]);
    const [contractModal, setContractModal] = useState<any>(null);
    const [contractCars, setContractCars] = useState<any>(null);
    const [contracts, setContracts] = useState<any[]>([]);
    const [customers, setCustomers] = useState<any[]>([]);
    const [plans, setPlans] = useState<any[]>([]);
    const [filters, setFilters] = useState<any>({
        status: "all",
        period: [],
    })
    const [loadingSaveContract, setLoadingSaveContract] = useState<boolean>(false);
    const [loadingData, setLoadingData] = useState<boolean>(false);

    const { str } = useLanguage();
    const { confirmDialog } = useApp();

    const loadData = async () => {
        try {
            setLoadingData(true);
            setContracts(await GET_ALL_CONTRACTS());
            setCars(await GET_ALL_CARS());
            setCustomers(await GET_ALL_CUSTOMERS());
            setPlans(await GET_ALL_PLANS());
        } catch (err: any) {
            showNotification({ message: err.message, color: "red" })
        } finally {
            setLoadingData(false);
        }
    }

    const saveStatus = async (contract: any, status: number) => {
        let params = { status };
        const prev = contracts;
        try {
            setContracts(cs => cs.map(c => c._id === contract._id ? { ...c, status } : c))
            await UPDATE_CONTRACT(contract._id, params)
            if ([2, 3].includes(status))
                await saveContract({
                    _id: contract._id,
                    cars: [
                        ...(contract.cars ?? []).map((c: any) => (
                            status === 2
                                ? c.start_at ? c : { ...c, start_at: moment().format() }
                                : c.finish_at ? c : { ...c, finish_at: moment().format() }
                        )),
                    ],
                })
        } catch (err: any) {
            setContracts(prev);
            showNotification({ message: err.message, color: "red" })
        }
    }

    const saveContract = async (contractUpdate: any = undefined) => {
        try {
            const contract = contractUpdate ?? contractModal;
            if (!contract._id) {
                setLoadingSaveContract(true);
                await CREATE_CONTRACT(contract)
                loadData();
                setContractModal(null);
                setContractCars(null);
            } else {
                setLoadingSaveContract(true);
                let params = { ...contract };
                delete params._id;
                await UPDATE_CONTRACT(contract._id, params)
                loadData();
                setContractModal(null);
                setContractCars(null);
            }
        } catch (err: any) {
            showNotification({ message: err.message, color: "red" })
        } finally {
            setLoadingSaveContract(false);
        }
    }

    useEffect(() => {
        loadData();
    }, [])

    return <>
        <Grid align='flex-end'>
            <Grid.Col span={{ md: 3 }}>
                <InputField
                    fieldType={InputFieldTypes.SELECT}
                    name="status"
                    title="Status"
                    clearable={false}
                    searchable={false}
                    value={filters.status}
                    onChange={(dt: any) => setFilters((f: any) => ({ ...f, ...dt }))}
                    options={[
                        { label: "Todos", value: "all" },
                        { label: "Agendados", value: "1" },
                        { label: "Retirados", value: "2" },
                        { label: "Devolvidos", value: "3" },
                    ]}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 3 }}>
                <InputField
                    fieldType={InputFieldTypes.DATERANGE}
                    name="period"
                    title="Período"
                    value={filters.period}
                    onChange={(dt: any) => setFilters((f: any) => ({ ...f, ...dt }))}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 4 }}>
            </Grid.Col>
            <Grid.Col span={{ md: 2 }}>
                <Button fullWidth loading={loadingData} onClick={() => setContractModal({})} leftSection={<FaPlus />}>Cadastrar</Button>
            </Grid.Col>
            <Grid.Col span={{ md: 12 }}>
                <Table
                    columns={[
                        {
                            title: "Status", key: "status", render: (item) => (
                                <Menu>
                                    <Menu.Target>
                                        {
                                            ({
                                                "1": <Badge color="gray">agendado</Badge>,
                                                "2": <Badge color="yellow">retirado</Badge>,
                                                "3": <Badge color="blue">devolvido</Badge>,
                                            }[item.status as string])
                                        }
                                    </Menu.Target>
                                    <Menu.Dropdown>
                                        {item.status === 1 && <Menu.Item
                                            disabled={!(item.cars ?? []).some((c: any) => !c.start_at)}
                                            onClick={() => saveStatus(item, 2)}
                                        >Retirar</Menu.Item>}
                                        {item.status === 2 && <Menu.Item
                                            onClick={() => saveStatus(item, 3)}
                                        >Devolver</Menu.Item>}
                                    </Menu.Dropdown>
                                </Menu>
                            )
                        },
                        { title: "Início", key: "start_at", render: (item) => getExtenseDatetime(item.start_at) },
                        { title: "Fim", key: "finish_at", render: (item) => getExtenseDatetime(item.finish_at) },
                        { title: "Cliente", key: "customer", render: (item) => item?.customer?.name },
                        {
                            title: "Veículo", key: "license_plate", render: (item) => {
                                const activeCar = (item?.cars ?? []).find((c: any) => !c.finish_at)
                                return <Button
                                    onClick={() => setContractCars({ _id: item._id, cars: item.cars ?? [] })}
                                    fullWidth
                                    variant='outline'
                                    disabled={item.status === 3}
                                >
                                    {
                                        activeCar
                                            ? [
                                                (activeCar?.car?.license_plate ?? ""),
                                                // (activeCar?.car?.brand?.title ?? ""),
                                                // (activeCar?.car?.model?.title ?? ""),
                                                // (activeCar?.car?.category?.title ?? ""),
                                                // str(`COLORS.${activeCar?.car?.color}`),
                                                // (activeCar?.car?.year ?? ""),
                                            ].join(", ")
                                            : "Alocar"
                                    }
                                </Button>
                            }
                        },
                    ]}
                    data={contracts.filter(c => (
                        (filters.status === "all" || filters.status == c.status) &&
                        (!filters.period[0] || moment(filters.period[0]).format("YYYY-MM-DD") <= moment(c.start_at).format("YYYY-MM-DD")) &&
                        (!filters.period[1] || moment(filters.period[1]).format("YYYY-MM-DD") >= moment(c.finish_at).format("YYYY-MM-DD"))
                    ))}
                    actions={[
                        { title: "Editar", onClick: ({ item }) => setContractModal(item) },
                        {
                            title: "Deletar", color: "red", onClick: ({ item }) => {
                                confirmDialog({ text: "Realmente deseja deletar esse contrato?" }, ({ confirmed }) => {
                                    if (confirmed) {
                                        let prev = contracts;
                                        setContracts(cs => cs.filter(c => c._id !== item._id));
                                        DELETE_CONTRACT(item._id)
                                            .then(() => { })
                                            .catch(err => {
                                                setContracts(prev);
                                                showNotification({ message: err.message, color: "red" })
                                            })
                                    }
                                })
                            }
                        },
                    ]}
                />
            </Grid.Col>
        </Grid>

        <Modal
            opened={!!contractCars}
            onClose={() => setContractCars(null)}
            size="md"
        >
            <Stack>
                <InputField
                    name="next"
                    value={contractCars?.next}
                    title="Veículo"
                    onChange={({ next }: any) => setContractCars((pv: any) => ({ ...pv, next }))}
                    fieldType={InputFieldTypes.SELECT}
                    options={cars.map(car => ({
                        label: [
                            car.model?.brand?.title,
                            car.model?.title,
                            car.model?.category?.title,
                            carColors.find(cc => cc.value === car.color)?.label,
                            car.year,
                        ].join(", "), value: car._id
                    }))}
                />
                <Group justify='flex-end'>
                    <Button
                        onClick={() => saveContract({
                            _id: contractCars._id,
                            cars: [
                                ...contractCars.cars.map((c: any) => c.finish_at ? c : { ...c, finish_at: moment().format() }),
                                { car: contractCars.next, start_at: null }
                            ],
                        })}
                        loading={loadingSaveContract}
                        disabled={!contractCars?.next}
                    >Salvar</Button>
                </Group>
            </Stack>
        </Modal>

        <Modal
            opened={!!contractModal}
            onClose={() => setContractModal(null)}
            size="lg"
        >
            <Stack>
                <InputField
                    name="customer"
                    value={contractModal?.customer?._id ?? contractModal?.customer}
                    title="Cliente"
                    onChange={({ customer }: any) => setContractModal((pv: any) => ({ ...pv, customer }))}
                    fieldType={InputFieldTypes.SELECT}
                    options={customers.map(b => ({ label: b.name, value: b._id }))}
                />
                <InputField
                    name="plan"
                    value={contractModal?.plan?._id ?? contractModal?.plan}
                    title="Plano"
                    onChange={({ plan }: any) => setContractModal((pv: any) => ({ ...pv, plan }))}
                    fieldType={InputFieldTypes.SELECT}
                    options={plans.map(b => ({ label: b.title, value: b._id }))}
                />
                <InputField
                    name="start_at"
                    value={contractModal?.start_at}
                    title="Retirada"
                    fieldType={InputFieldTypes.DATETIME}
                    onChange={({ start_at }: any) => setContractModal((pv: any) => ({ ...pv, start_at }))}
                />
                <InputField
                    name="finish_at"
                    value={contractModal?.finish_at}
                    title="Devolução"
                    fieldType={InputFieldTypes.DATETIME}
                    onChange={({ finish_at }: any) => setContractModal((pv: any) => ({ ...pv, finish_at }))}
                />

                <Group justify='flex-end'>
                    <Button
                        onClick={() => saveContract()}
                        loading={loadingSaveContract}
                        disabled={!contractModal?.start_at || !contractModal?.finish_at || !contractModal?.plan || !contractModal?.customer}
                    >Salvar</Button>
                </Group>
            </Stack>
        </Modal>
    </>
}
